import {
  TemplateNodeSchema,
  TemplateNodeTypeEnum,
} from '@ulysses-inc/harami_api_client'
import React from 'react'
import { MoveNodeEvent } from 'src/features/templateEdit/dragAndDrop/DnDTemplateType'
import { SectionBackgroundColor } from 'src/features/theme/KdsThemeColor'
import styled from 'styled-components'
import StyledIndentation from '../common/StyledIndentation'
import AddTemplateModifyButtonGroupInEmpty from '../itemAppender/AddTemplateModifyButtonGroupInEmpty'
import Question from '../question/Question'
import SectionContainer from './Section'
import { TableSectionEditor } from './table'
import { isTableSectionNode } from './table/model'

const SectionContentContainer = styled.div`
  display: flex;
`

const SectionContentWrapper = styled.div`
  flex: 1;
  /* flex アイテムのデフォルト min-width: auto を打ち消す。これがないと表セクションの
     プレビュー(width: max-content)が縮まずに親を押し広げ、横スクロールではなく
     画面外へはみ出してしまう。 */
  min-width: 0;
`

interface OwnProps {
  node: TemplateNodeSchema
  activeNodeId: number
  path: number[]
  useTemplateNodeNodes: (
    templateNode: TemplateNodeSchema,
  ) => Array<TemplateNodeSchema>
  addTemplateNode: (
    targetNode: TemplateNodeSchema | null,
    parentNode: TemplateNodeSchema | null,
    position: 'top' | 'bottom',
    addTemplateNodeType: TemplateNodeTypeEnum,
  ) => void
  moveNode: (event: MoveNodeEvent) => void
}

const SectionContent: React.FC<OwnProps> = (props: OwnProps) => {
  const templateNodeNodes = props.useTemplateNodeNodes(props.node)

  return (
    <SectionContentContainer key={props.node.id} data-testid="section-content">
      <StyledIndentation color={SectionBackgroundColor} />
      <SectionContentWrapper>
        {isTableSectionNode(props.node) ? (
          <TableSectionEditor
            tableNode={props.node}
            activeNodeId={props.activeNodeId}
          />
        ) : props.node.nodes.length === 0 ? (
          <AddTemplateModifyButtonGroupInEmpty
            node={props.node}
            parentNode={props.node}
            addTemplateNode={props.addTemplateNode}
            moveNode={props.moveNode}
          />
        ) : (
          templateNodeNodes.map((node, index) => {
            if (node.type === TemplateNodeTypeEnum.Question) {
              return (
                <Question
                  key={node.id}
                  node={node}
                  parentNode={props.node}
                  path={[...props.path, props.node.id]}
                  isActive={props.activeNodeId === node.id}
                  isLastChild={templateNodeNodes.length === index + 1}
                />
              )
            }
            return (
              <SectionContainer
                key={node.id}
                node={node}
                parentNode={props.node}
                path={[...props.path, props.node.id]}
                isActive={props.activeNodeId === node.id}
              />
            )
          })
        )}
      </SectionContentWrapper>
    </SectionContentContainer>
  )
}

export default SectionContent
